<template>
  <div class="container">
    <div class="handle-box">
      <el-cascader :props="props" v-model="area_store" placeholder="选择或搜索门店" @visible-change="visibleChange"
        @change="clearRoom" style="margin-right: 10px;" collapse-tags clearable filterable></el-cascader>
      <el-select v-model="query.roomId" clearable placeholder="房间" style="width: 160px;margin-right: 4px;">
        <el-option v-for="itm in roomOptions" :key="itm.value" :label="itm.label"
          :value="Number(itm.value)"></el-option>
      </el-select>
      <el-select v-model="query.is_online" clearable placeholder="状态" class="handle-input mr10" @clear="clearOnline">
        <el-option v-for="item in onlineOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="query.code" placeholder="设备编码" class="handle-input mr10 w150"></el-input>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
      <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
      <el-table-column prop="code" label="设备编码" align="center"></el-table-column>
      <el-table-column prop="name" label="设备名称" align="center"></el-table-column>
      <el-table-column label="在线状态" width="100" align="center">
        <template #default="scope">
          <span :style="'color:' + [scope.row.is_online ? '' : 'red']">
            {{ scope.row.is_online ? "在线" : "离线" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" header-align="center" label="所在门店" prop="store_name"></el-table-column>
      <el-table-column align="center" header-align="center" label="所在包厢" prop="room_name"></el-table-column>
      <el-table-column align="center" header-align="center" label="提示" prop="msg"
        show-overflow-tooltip></el-table-column>
      <el-table-column :formatter="dateFormatHMS" align="center" header-align="center" label="更新时间"
        prop="u_at"></el-table-column>
      <el-table-column align="center" header-align="center" label="操作" width="150">
        <template #default="scope">
          <el-button type="text" @click="getOperationLog(scope.row.code)">操作日志</el-button>
          <el-button type="text" @click="getConnectionLog(scope.row.code)">连接日志</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100, 200]" :page-size="10" layout="total,sizes, prev, pager, next" :total="pageTotal">
      </el-pagination>
    </div>
    <!-- 连接日志的弹框 -->
    <el-dialog v-model="connectVisible" :title="connName" width="80%" @close="connectVisible = false">
      <el-table :data="connData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
        <el-table-column prop="id" label="ID" width="155" align="center"></el-table-column>
        <el-table-column prop="code" label="设备编码" align="center"></el-table-column>
        <el-table-column prop="is_online" label="在线状态" align="center">
          <template #default="scope">
            <span :style="'color:' + [scope.row.is_online ? '' : 'red']">
              {{ scope.row.is_online ? "在线" : "离线" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="msg" label="提示" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :formatter="dateFormatHMS" prop="c_at" label="操作时间" align="center"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleConnSizeChange" @current-change="handleConnPageChange"
          :current-page="conn_query.page" :page-sizes="[10, 20, 50, 100, 200]" :page-size="10"
          layout="total,sizes, prev, pager, next" :total="connPageTotal">
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 操作日志的弹框 -->
    <el-dialog v-model="operationVisible" :title="operationName" width="80%" @close="operationVisible = false">
      <el-table :data="operationData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
        <el-table-column prop="id" label="ID" width="155" align="center"></el-table-column>
        <el-table-column prop="code" label="设备编码" align="center"></el-table-column>
        <el-table-column prop="note" label="操作内容" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :formatter="dateFormatHMS" prop="c_at" label="操作时间" align="center"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleOperationSizeChange" @current-change="handleOperationPageChange"
          :current-page="operation_query.page" :page-sizes="[10, 20, 50, 100, 200]" :page-size="10"
          layout="total,sizes, prev, pager, next" :total="operationPageTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getConnList, getDeviceOperation, getDeviceConn } from '@/api/device'
import { getAreaOption, getStoreOption } from "@/api/store";
import { getRoomOption } from '@/api/room'
import moment from "moment";
export default {
  data() {
    return {
      query: {
        is_online: null,
        code: '',
        storeId: null,
        roomId: null,
        page: 1,
        page_size: 10
      },
      onlineOptions: [
        {
          value: false,
          label: '离线'
        },
        {
          value: true,
          label: '在线'
        }
      ],
      tableData: [],
      pageTotal: 0,
      connectVisible: false,
      areaOptions: [],
      area_store: [],
      props: {
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      connName: '连接日志',
      conn_query: {
        page: 1,
        pageSize: 10,
        code: null
      },
      operationVisible: false,
      operationName: '操作日志',
      operation_query: {
        page: 1,
        pageSize: 10,
        code: null
      },
      connData: [],
      operationData: [],
      operationPageTotal: 0,
      connPageTotal: 0,
      roomOptions: []
    }
  },
  created() {
    this.getData()
    this.getStoreOption();
  },
  methods: {
    dateFormatHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    clearOnline() {
      delete this.query.is_online
    },
    getData() {
      getConnList(this.query).then(res => {
        this.tableData = res.data
        if (res.count) {
          this.pageTotal = res.count
        }
      })
    },
    lazyLoad(node, resolve) {
      const { level } = node;
      if (level === 0) {
        this.getAreaOptions()
        let nodes = []
        if (this.areaOptions !== []) {
          setTimeout(() => {
            nodes = this.areaOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
      if (level === 1) {
        let nodes = []
        this.getStoreOption(node.value)
        if (this.storeOptions !== []) {
          setTimeout(() => {
            nodes = this.storeOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
    },
    visibleChange(val) {
      setTimeout(() => {
        if (!val && this.area_store != null && this.area_store.length > 1) {
          this.query.storeId = this.area_store[1]
          this.getRoomOption(this.query.storeId)
        }
      }, 200)
    },
    // 获取地址列表
    getAreaOptions() {
      getAreaOption().then(res => {
        this.areaOptions = res
      })
    },
    getStoreOption(id) {
      getStoreOption(id).then(res => {
        this.storeOptions = res
      })
    },
    // 获取房间信息
    getRoomOption(id) {
      this.query.room_id = null
      getRoomOption(id).then(res => {
        this.roomOptions = res
      })
    },
    clearRoom(val) {
      if (val === null) {
        this.roomOptions = []
        this.query.room_id = null
      }
    },
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    // 每页大小变化
    handleSizeChange(val) {
      this.query.page_size = val
      this.getData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
    // 每页大小变化
    handleOperationSizeChange(val) {
      this.operation_query.pageSize = val
      this.getOprationData()
    },

    // 分页导航
    handleOperationPageChange(val) {
      this.operation_query.page = val
      this.getOprationData()
    },
    // 每页大小变化
    handleConnSizeChange(val) {
      this.conn_query.pageSize = val
      this.getConnData()
    },

    // 分页导航
    handleConnPageChange(val) {
      this.conn_query.page = val
      this.getConnData()
    },
    // 获取操作日志
    getOperationLog(code) {
      this.operation_query.page = 1
      this.operationName = code + '的操作日志'
      this.operation_query.code = code
      this.getOprationData()
      this.operationVisible = true
    },
    getOprationData() {
      getDeviceOperation(this.operation_query).then(res => {
        this.operationData = res.data.list
        this.operationPageTotal = res.data.total
      })
    },
    // 获取连接日志
    getConnectionLog(code) {
      this.conn_query.page = 1
      this.connName = code + '的连接日志'
      this.conn_query.code = code
      this.getConnData()
      this.connectVisible = true
    },
    getConnData() {
      getDeviceConn(this.conn_query).then(res => {
        this.connData = res.data.list
        this.connPageTotal = res.data.total
      })
    },
  }
}

</script>

<style scoped>
.el-select {
  margin-right: 10px;
  width: 100px;
}

.el-input {
  width: 200px;
  margin-right: 10px;
}

.handle-box {
  margin-bottom: 20px;
}

.red {
  color: red;
}
</style>